import { apiClient } from './request';
import { create, fromJson, type JsonValue, toJson } from '@bufbuild/protobuf';
import {
  type GetOverviewData,
  GetOverviewRequestSchema,
  GetOverviewResponseSchema,
} from '@/proto/agentplatform/httpv2/observability_pb';

export const baseApi = {
  overview: async (): Promise<GetOverviewData | undefined> => {
    const req = create(GetOverviewRequestSchema, {});
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetOverview',
      toJson(GetOverviewRequestSchema, req)
    );
    const resp = fromJson(GetOverviewResponseSchema, responseObject.data);
    return resp.data;
  },
};
